import React from 'react'

const SOURCES = [
  { name: 'ERA5',               desc: 'ECMWF reanalysis — temperature, wind, solar radiation, precipitation' },
  { name: 'Open-Meteo',         desc: 'High-resolution hourly weather forecasts and historical data' },
  { name: 'Global Solar Atlas', desc: 'Long-term solar irradiance climatology at ~1 km resolution' },
  { name: 'Sentinel-2',         desc: 'Copernicus satellite imagery — NDVI, land use, 10 m resolution' },
  { name: 'OpenStreetMap',      desc: 'Substations, power lines, roads, and settlement infrastructure' },
  { name: 'World Bank',         desc: 'Electrification rates, GDP per capita, renewable energy share' },
]

const REGIONS = [
  { label: 'Indonesia', center: [-2.5,  118.0] },
  { label: 'Kenya',     center: [0.0,    38.0] },
  { label: 'Vietnam',   center: [16.0,  106.0] },
]

function NorthflowMark({ size = 36 }) {
  return (
    <svg width={size} height={size} viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M16 4 L8 26 L16 21 Z" fill="#22d3ee"/>
      <path d="M16 4 L24 26 L16 21 Z" fill="#22d3ee" fillOpacity="0.22"/>
      <circle cx="16" cy="27.5" r="1.8" fill="#22d3ee" fillOpacity="0.45"/>
    </svg>
  )
}

export default function AboutPanel({ onFlyTo }) {
  return (
    <div className="about-panel">

      {/* Map context — country quick-fly */}
      <div className="card">
        <div className="card__title">Map view</div>
        <div className="about-regions">
          {REGIONS.map(r => (
            <button
              key={r.label}
              className="region-btn"
              onClick={() => onFlyTo(r.center)}
            >
              {r.label}
            </button>
          ))}
        </div>
      </div>

      {/* Identity */}
      <div className="card about-card--identity">
        <div className="about-header">
          <NorthflowMark size={38} />
          <div className="about-header__wordmark">
            <span className="about-header__company">Northflow</span>
            <span className="about-header__product">FLUX</span>
          </div>
        </div>
        <p className="about-body">
          <strong>FLUX</strong> is an AI-powered platform for renewable energy siting and yield prediction.
          Drop a pin anywhere on the map to run a full site assessment — resource analysis,
          grid connectivity, financial modelling, and climate risk, in seconds.
        </p>
      </div>

      {/* How it works */}
      <div className="card">
        <div className="card__title card__title--accented">How it works</div>
        <p className="about-body">
          Every assessment fuses live data from six Earth observation sources through the{' '}
          <strong>PSE Planetary Sensing Engine</strong> — Northflow's open-source spatiotemporal
          data platform. Quality-weighted fusion blends overlapping sources intelligently,
          producing the most accurate picture of any site on Earth.
        </p>
      </div>

      {/* Data sources */}
      <div className="card about-card--sources">
        <div className="card__title card__title--accented">Data sources</div>
        <div className="about-sources">
          {SOURCES.map(s => (
            <div className="about-source" key={s.name}>
              <span className="about-source__name">{s.name}</span>
              <span className="about-source__desc">{s.desc}</span>
            </div>
          ))}
        </div>
      </div>

      {/* Links */}
      <div className="card">
        <div className="card__title card__title--accented">Links</div>
        <div className="about-links">
          <a className="about-link about-link--accent" href="https://pse.northflow.no/api/v1/health" target="_blank" rel="noreferrer">
            PSE API
          </a>
          <a className="about-link about-link--accent" href="https://github.com/northflowlabs/pse" target="_blank" rel="noreferrer">
            GitHub
          </a>
          <a className="about-link about-link--accent" href="https://northflow.no" target="_blank" rel="noreferrer">
            northflow.no
          </a>
        </div>
        <div className="about-footer">
          FLUX is proprietary software built on the open-source PSE platform (Apache 2.0).<br />
          © 2026 Northflow Technologies AS · Stavanger, Norway
        </div>
      </div>

    </div>
  )
}
